<template>
  <div>
    <el-row class="bg-color-w py-20 px-30">
      <el-row class="">
        <div class="float-l wt-450 dy-flex">
          <!-- 选择被授权人 -->
          <InputBox
            :id="'bsqr'"
            class=""
            v-model="ryValue"
            :uniqueNum="uniqueNum"
            :suffixicon="'el-icon-search'"
            @contentChange="contentChange"
            @suffixIconClick="suffixIconClick"
            :inputData="getArgumentDetail('bsqrTil')"
            :clearable="true"
            @inputClear="clearBsqr"
          >
            <div slot="left" class="float-l">
              {{ $t("xmsq.queryFormbsqr") }}：
            </div>
          </InputBox>
          <el-button
            class="mx-10"
            type="primary"
            size="mini"
            @click="suffixIconClick()"
            >{{ $t("common.searchBtn") }}
          </el-button>
        </div>
        <div class="float-r dy-flex">
          <!-- 批量取消授权部门 -->
          <ButtonBox
            type="primary"
            :id="'plqx'"
            :buttonData="getArgumentDetail('plqxTil')"
            @click.native="plqxBmsq"
            :uniqueNum="uniqueNum"
            class=""
            :icon="'el-icon-close'"
          ></ButtonBox>
        </div>
      </el-row>
      <el-row class="ht-15">
        <div class="float-l pt-5 pl-80" v-if="flg == '1'">
          {{ ryxx.rydm }}
        </div>
        <div class="float-l pt-5 pl-80" v-if="flg == '2'">
          {{ ryxx.xm }}
        </div>
      </el-row>
      <el-row class="mt-20">
        <!-- 动态表格组件 -->
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :currentPage="currentPage"
          :limit="limit"
          :uniqueNum="uniqueNum"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          :height="$store.state.screenHeight - 285"
          @handleSelection="handleSelection"
          @selectionAll="selectionAll"
          @handleClickFun="handleClickFun"
        ></TableCommon>
      </el-row>
      <el-row>
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </el-row>
    <!-- 查询被授权人 -->
    <xmsqry-dialog
      :title="$t('xmsq.xzbsqr')"
      :dialogbsqr="dialogbsqr"
      :tableData="ryxxData"
      :uniqueNum="'Y120102-1-2'"
      :cancelText="$t('common.cancelBtn')"
      :confirmText="$t('common.confirmBtn')"
      @confirm="confirm"
      @cancel="cancel"
    >
      <el-row slot="page">
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage2"
          :total="total2"
          :limit="limit2"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange2"
          @handleSizeChange="handleSizeChange2"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/qhsqgl";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";

export default {
  // 取消授权项目
  name: "removeAuzBm",
  components: {
    XmsqryDialog,
  },
  computed: {},
  data() {
    return {
      tabLoading: true,
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      currentPage2: 1,
      limit2: this.$store.state.dataDisplayNum,
      total2: 0, // 数据量
      tableColumns: [],
      tableData: [],
      uniqueNum: "Y120127-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      ryValue: "",
      bsqr: "",
      flg: "0",
      saveflg: "0",
      ryxx: null,
      ryxxData: [],
      activeTableData: [],
      rydm: null,
      dialogbsqr: false,
      multipleChoice: [],
      queryForm: {}, // 查询条件
      argumentDetail: {},
      argumentConfig: {
        bsqrTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "input-bsqr",
        },
        plqxTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-plqx",
        },
      },
      show: [],
    };
  },
  methods: {
    //   获取当前用户授权部门
    getYsqbm() {
      let params = {};
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      params.bsqr = this.rydm;
      sqgl.getYsqbm(params).then((res) => {
        this.tableData = res.data.data;
        if (this.tableData.length > 0) {
          this.total = this.tableData[0].count;
        }
        this.tabLoading = false;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getYsqbm();
    },
    /** 页码改变时会触发 */
    handleCurrentChange2(uniqueNum, val) {
      this.currentPage2 = val;
      this.dataPaging(this.activeTableData);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.currentPage = 1;
      this.limit = val;
      this.getYsqbm();
    },
    /** 每页条数改变时触发 */
    handleSizeChange2(uniqueNum, val) {
      this.currentPage2 = 1;
      this.limit2 = val;
      this.dataPaging(this.activeTableData);
    },
    // 被授权人数据分页
    dataPaging(activeTableData) {
      this.ryxxData = [];
      if (activeTableData) {
        this.total2 = activeTableData.length;
        if (activeTableData.length <= (this.currentPage2 - 1) * this.limit2) {
          this.currentPage2 = 1;
        }
        let i = (this.currentPage2 - 1) * this.limit2;
        for (
          i;
          i < this.currentPage2 * this.limit2 && i < activeTableData.length;
          i++
        ) {
          this.ryxxData.push(activeTableData[i]);
        }
      }
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120127";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    // 选中表格时方法
    handleSelection(selection, row) {
      this.multipleChoice = [];
      this.multipleChoice = selection;
    },
    // 表格点击全选时方法
    selectionAll(selection) {
      this.multipleChoice = [];
      this.multipleChoice = selection;
    },
    // 查询项目人员
    suffixIconClick() {
      let arr = [];
      if (this.bsqr != null && this.bsqr != "") {
        yhxx.getSysUser({ rydm: this.bsqr }).then((res) => {
          let res1 = res.data.data;
          arr = res1.ryxx;
          this.flg = res1.flg;
          switch (res1.ryxx.length) {
            case 0:
              this.$message({
                message: "未找到用户,请检查后重试",
                type: "error",
              });
              break;
            case 1:
              this.ryxx = arr[0];
              if (this.flg == "1") {
                this.bsqr = arr[0].xm;
                this.ryValue = arr[0].xm;
              } else {
                this.bsqr = arr[0].rydm;
                this.ryValue = arr[0].rydm;
              }
              this.rydm = arr[0].rydm;
              this.getYsqbm();
              break;
            default:
              this.dialogbsqr = true;
              this.activeTableData = res1.ryxx;
              this.dataPaging(this.activeTableData);
              break;
          }
        });
      } else {
        this.flg = "0";
        this.rydm = null;
        this.getYsqbm();
      }
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120127",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    contentChange(val) {
      this.bsqr = val;
    },
    // 清空项目人员
    clearBsqr() {
      this.rydm = null;
      this.flg = "0";
      this.getYsqbm();
    },
    // 选择人员
    confirm(val) {
      this.dialogbsqr = false;
      this.ryxx = val[0];
      if (this.flg == "1") {
        this.bsqr = val[0].xm;
        this.ryValue = val[0].xm;
      } else {
        this.bsqr = val[0].rydm;
        this.ryValue = val[0].rydm;
      }
      this.rydm = val[0].rydm;
      this.getYsqbm();
    },
    // 取消选择人员
    cancel() {
      this.dialogbsqr = false;
    },
    // 取消部门授权
    qxBmsq(row) {
      this.$confirm(
        this.$t("xmsq.sfqx") +
          row.bmbh +
          "/" +
          row.bmmc +
          this.$t("xmsq.zgsqbm"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirmBtn"),
          cancelButtonText: this.$t("common.cancelBtn"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          sqgl.qxBmsq(row).then((res) => {
            this.getYsqbm();
            if (res.data.code == "200") {
              this.$message({
                message: res.data.data,
                type: "success",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("xmsq.Operationcancel"),
          });
        });
    },
    // 批量取消部门授权
    plqxBmsq() {
      if (this.multipleChoice.length > 0) {
        this.$confirm(
          this.$t("xmsq.sfqx") +
            this.multipleChoice.length +
            this.$t("xmsq.gbm"),
          this.$t("common.tips"),
          {
            confirmButtonText: this.$t("common.confirmBtn"),
            cancelButtonText: this.$t("common.cancelBtn"),
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            sqgl.plqxBmsq(this.multipleChoice).then((res) => {
              this.getYsqbm();
              this.$message({
                message: res.data.data,
                type: "success",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("xmsq.Operationcancel"),
            });
          });
      } else {
        this.$message({
          message: this.$t("xmsq.Noselect"),
          type: "warning",
        });
      }
    },
    // 点击按钮或链接
    handleClickFun(row) {
      if (row.oprationflg.en == "qxBmsq") {
        this.qxBmsq(row.row);
      }
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.suffixIconClick();
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
    this.getYsqbm();
    this.getPageTableConfig();
    this.loadQueryConfig();
  },
  destroyed: function() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style lang="scss" scoped></style>
